<nz-layout>
    <nz-content>
        <div #printDiv class="card padded" style="overflow: auto">
            <ng-container [ngSwitch]="template?.id">
                <ng-container *ngSwitchCase="'bc'">
                    <app-lab-req-bc #base [templateVariant]="template?.variant" [customerGender]="customer?.gender"></app-lab-req-bc>
                </ng-container>
                <ng-container *ngSwitchCase="'qc'">
                    <app-lab-req-qc #base [templateVariant]="template?.variant" [customerGender]="customer?.gender"></app-lab-req-qc>
                </ng-container>
                <ng-container *ngSwitchCase="'sk'">
                    <app-lab-req-sk #base [templateVariant]="template?.variant" [customerGender]="customer?.gender"></app-lab-req-sk>
                </ng-container>
                <ng-container *ngSwitchCase="'ab'">
                    <app-lab-req-ab #base [templateVariant]="template?.variant" [customerGender]="customer?.gender"></app-lab-req-ab>
                </ng-container>
                <ng-container *ngSwitchCase="'nf'">
                    <app-lab-req-nf #base [templateVariant]="template?.variant" [customerGender]="customer?.gender"></app-lab-req-nf>
                </ng-container>
                <ng-container *ngSwitchCase="'on'">
                    <app-lab-req-on #base [templateVariant]="template?.variant" [customerGender]="customer?.gender"></app-lab-req-on>
                </ng-container>
                <ng-container *ngSwitchCase="'lgvon'">
                    <app-lab-req-on #base [templateVariant]="template?.variant" [customerGender]="customer?.gender"></app-lab-req-on>
                </ng-container>

                <p *ngSwitchDefault>Unsupported Lab Req</p>
            </ng-container>
        </div>

        <nz-divider></nz-divider>

        <div class="ml-1">
            <nz-form-item>
                <nz-form-label [nzFor]="'dueDate'" [nzRequired]="true"
                    >Due Date</nz-form-label
                >
                <nz-form-control>
                    <nz-date-picker
                        id="dueDate"
                        nzFormat="yyyy-MM-dd"
                        [(ngModel)]="dueDate"
                        nzPlaceHolder="Select Due Date"
                        [nzRenderExtraFooter]="footerTemplate"
                    ></nz-date-picker>
                    <ng-template #footerTemplate>
                        <button nz-button nzType="link" (click)="setDueDate(3)">
                            3 Months
                        </button>
                        <button nz-button nzType="link" (click)="setDueDate(6)">
                            6 Months
                        </button>
                        <button
                            nz-button
                            nzType="link"
                            (click)="setDueDate(12)"
                        >
                            1 Year
                        </button>
                    </ng-template>
                </nz-form-control>
            </nz-form-item>
        </div>

        <nz-divider></nz-divider>

        <div style="padding: 0 3rem">
            <nz-alert
                *ngIf="showAlert"
                nzType="error"
                nzMessage="Please make sure all required fields above are entered correctly"
            ></nz-alert>
        </div>

        <div nz-row nzType="flex" nzJustify="space-around" class="button-group">
            <button
                nz-button
                nzType="primary"
                nzShape="round"
                (click)="saveLabReq()"
                [nzLoading]="saving"
            >
                {{ labReq ? 'Save Lab Req' : 'Create Lab Req' }}
            </button>
            <button
                nz-button
                nzType="primary"
                nzShape="round"
                (click)="close()"
                [disabled]="saving"
            >
                Cancel
            </button>
        </div>
    </nz-content>
</nz-layout>
